import type { AuthConfigNanoId, ConnectedAccountNanoId, OrgNanoId, ProjectNanoId, TriggerInstanceNanoId } from "@composio/types";
// This file is auto-generated by @hey-api/openapi-ts

export type EmptyResponse = {
    [key: string]: unknown;
};

export type Error = {
    error: {
        message: string;
        code: number;
        status: number;
        request_id?: string;
        suggested_fix?: string;
        errors?: Array<(string)>;
    };
};

export type InviteTeamMemberBody = {
    email: string;
    name: string;
    role: string;
    verifyHost?: string;
};

export type UpdateTeamMemberBody = {
    name: string;
    email: string;
    role: string;
};

export type GetAuthByProviderNameCallbackData = {
    authCode?: string;
    code?: string;
    error?: string;
    errorDescription?: string;
    providerName: 'github' | 'google';
    state?: string;
};

export type GetAuthByProviderNameCallbackResponse = ({
    message: string;
    data: {
        jwtToken: string;
        userData: {
            email: string;
        };
    };
} | void);

export type GetAuthByProviderNameLoginData = {
    providerName: string;
    redirectUri?: string;
};

export type PostAuthByProviderNameOneTapData = {
    providerName: 'github' | 'google';
    requestBody?: ({
    data: {
        jwt: string;
    };
    type: 'jwt';
} | {
    data: {
        authCode: string;
    };
    type: 'auth-code';
});
};

export type PostAuthByProviderNameOneTapResponse = ({
    clientId: (string) | null;
    apiKey: (string) | null;
    email: (string) | null;
    orgId: (string) | null;
});

export type PostAuthMagicLinkSendData = {
    requestBody?: {
        email: string;
        verifyHost?: string;
        isMCP?: boolean;
    };
};

export type PostAuthMagicLinkSendResponse = ({
    status: string;
});

export type PostAuthMagicLinkVerifyData = {
    requestBody?: {
        token: string;
    };
};

export type PostAuthMagicLinkVerifyResponse = ({
    message: string;
    data: {
        jwtToken: string;
        orgId: string;
        email: string;
        memberId: string;
    };
});

export type GetAuthSessionInfoResponse = ({
    project: {
        autoId: number;
        id: string;
        orgId: string;
        name: string;
        email: string;
        /**
         * Nano ID of the project
         */
        nanoId: ProjectNanoId;
        createdAt: string;
        updatedAt: string;
        webhookURL: (string) | null;
        eventWebhookURL: (string) | null;
        webhookSecret: (string) | null;
        triggersEnabled: boolean;
        lastSubscribedAt: (string) | null;
        deleted: boolean;
        isNewWebhook: boolean;
        org: {
            id: OrgNanoId;
            name: string;
            plan: string;
            orgMembers: Array<{
                autoId: number;
                id: string;
                orgId: string;
                email: string;
                name: string;
                role: string;
                metadata?: unknown;
                createdAt: string;
                updatedAt: string;
                deletedAt: (string) | null;
            }>;
        };
    } | null;
    apiKey: {
        autoId: number;
        id: string;
        name: string;
        /**
         * Nano ID of the project
         */
        projectId: ProjectNanoId;
        orgMemberId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt: (string) | null;
        key: string;
        deleted: boolean;
    } | null;
    org_member: {
        id: string;
        email: string;
        name: string;
        role: string;
    };
});

export type PostAuthSessionLogoutResponse = ({
    /**
     * Status message
     */
    message: string;
});

export type PostAdminIdentifyData = {
    requestBody?: {
        hash: string;
    };
};

export type PostAdminIdentifyResponse = ({
    clientId: string;
    apiKey: string;
    email: string;
    orgId: string;
});

export type GetAdminConnectionsData = {
    /**
     * The toolkit slug to filter connections by
     */
    toolkitSlug: string;
    /**
     * Admin token
     */
    xComposioAdminToken: string;
};

export type GetAdminConnectionsResponse = ({
    items: Array<{
        /**
         * The nano ID of the connected account
         */
        id: string;
    }>;
});

export type PostAdminAuthRefreshData = {
    requestBody?: {
        /**
         * Array of connection IDs to refresh tokens for
         */
        connectionIds: Array<(string)>;
        /**
         * Maximum parallel refresh operations (1-20)
         */
        parallelism?: number;
    };
    /**
     * Admin token
     */
    xComposioAdminToken: string;
};

export type PostAdminAuthRefreshResponse = ({
    /**
     * Array of connection IDs that were successfully refreshed
     */
    success: Array<(string)>;
    /**
     * Array of connections that failed to refresh with error details
     */
    failures: Array<{
        /**
         * Connection ID that failed
         */
        connectionId: string;
        /**
         * Error code describing the failure reason
         */
        error: string;
    }>;
});

export type PostAuthConfigsData = {
    requestBody?: {
        toolkit: {
            /**
             * List of app unique keys to filter by
             */
            slug: string;
        };
        auth_config?: ({
    type: 'use_composio_managed_auth';
    /**
     * The name of the integration
     */
    name?: string;
    credentials?: {
        [key: string]: (string | boolean | number);
    };
    /**
     * The actions that the user can perform on the auth config
     */
    restrict_to_following_tools?: Array<(string)>;
} | {
    type: 'use_custom_auth';
    /**
     * The name of the integration
     */
    name?: string;
    authScheme: 'OAUTH2' | 'OAUTH1' | 'OAUTH1A' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH' | 'SNOWFLAKE';
    credentials: {
        [key: string]: (string | boolean | number);
    };
    /**
     * The actions that the user can perform on the auth config
     */
    restrict_to_following_tools?: Array<(string)>;
});
    };
};

export type PostAuthConfigsResponse = ({
    toolkit: {
        /**
         * The unique key of the toolkit
         */
        slug: string;
    };
    auth_config: {
        /**
         * The auth config id of the app (must be a valid auth config id)
         */
        id: AuthConfigNanoId;
        /**
         * The authentication mode of the app
         */
        auth_scheme: string;
        /**
         * Whether the auth config is managed by Composio
         */
        is_composio_managed: boolean;
        /**
         * The actions that the user can perform on the auth config
         */
        restrict_to_following_tools?: Array<(string)>;
    };
});

export type GetAuthConfigsData = {
    /**
     * The cursor to paginate through the auth configs
     */
    cursor?: string;
    /**
     * The app id to filter by
     */
    deprecatedAppId?: string;
    deprecatedStatus?: string;
    /**
     * Whether to filter by composio managed auth configs
     */
    isComposioManaged?: (string | boolean);
    /**
     * The number of auth configs to return
     */
    limit?: string;
    /**
     * The slug of the toolkit to filter by
     */
    toolkitSlug?: string;
};

export type GetAuthConfigsResponse = ({
    items: Array<{
        /**
         * The unique id of the auth config
         */
        id: AuthConfigNanoId;
        /**
         * The unique id of the auth config
         */
        uuid: string;
        /**
         * The type of the auth config
         */
        type: 'default' | 'custom';
        toolkit: {
            /**
             * The unique key of the app
             */
            slug: string;
            /**
             * The logo of the app
             */
            logo: string;
        };
        /**
         * The name of the auth config
         */
        name: string;
        auth_scheme?: 'OAUTH2' | 'OAUTH1' | 'OAUTH1A' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH' | 'SNOWFLAKE';
        is_composio_managed?: boolean;
        credentials?: {
            [key: string]: unknown;
        };
        status: 'ENABLED' | 'DISABLED';
        /**
         * The user who created the auth config
         */
        created_by?: string;
        /**
         * The date and time the auth config was created
         */
        created_at?: string;
        /**
         * The date and time the auth config was last updated
         */
        last_updated_at?: string;
        /**
         * The number of connections for the auth config
         */
        no_of_connections: number;
        expected_input_fields?: Array<unknown>;
        restrict_to_following_tools?: Array<(string)>;
        deprecated_params: {
            default_connector_id: (string) | null;
            member_uuid?: string;
            toolkit_id?: string;
            expected_input_fields?: Array<{
                [key: string]: unknown;
            }>;
        };
    }>;
    next_cursor: (string) | null;
    total_pages: number;
});

export type GetAuthConfigsByNanoidData = {
    nanoid: AuthConfigNanoId;
};

export type GetAuthConfigsByNanoidResponse = ({
    /**
     * The unique id of the auth config
     */
    id: AuthConfigNanoId;
    /**
     * The unique id of the auth config
     */
    uuid: string;
    /**
     * The type of the auth config
     */
    type: 'default' | 'custom';
    toolkit: {
        /**
         * The unique key of the app
         */
        slug: string;
        /**
         * The logo of the app
         */
        logo: string;
    };
    /**
     * The name of the auth config
     */
    name: string;
    auth_scheme?: 'OAUTH2' | 'OAUTH1' | 'OAUTH1A' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH' | 'SNOWFLAKE';
    is_composio_managed?: boolean;
    credentials?: {
        [key: string]: unknown;
    };
    status: 'ENABLED' | 'DISABLED';
    /**
     * The user who created the auth config
     */
    created_by?: string;
    /**
     * The date and time the auth config was created
     */
    created_at?: string;
    /**
     * The date and time the auth config was last updated
     */
    last_updated_at?: string;
    /**
     * The number of connections for the auth config
     */
    no_of_connections: number;
    expected_input_fields?: Array<unknown>;
    restrict_to_following_tools?: Array<(string)>;
    deprecated_params: {
        default_connector_id: (string) | null;
        member_uuid?: string;
        toolkit_id?: string;
        expected_input_fields?: Array<{
            [key: string]: unknown;
        }>;
    };
});

export type PatchAuthConfigsByNanoidData = {
    nanoid: AuthConfigNanoId;
    requestBody?: ({
    type: 'custom';
    credentials: {
        [key: string]: unknown;
    };
    restrict_to_following_tools?: Array<(string)>;
} | {
    type: 'default';
    scopes: string;
    restrict_to_following_tools?: Array<(string)>;
});
};

export type PatchAuthConfigsByNanoidResponse = ({
    [key: string]: unknown;
});

export type DeleteAuthConfigsByNanoidData = {
    nanoid: AuthConfigNanoId;
};

export type DeleteAuthConfigsByNanoidResponse = ({
    [key: string]: unknown;
});

export type PatchAuthConfigsByNanoidByStatusData = {
    nanoid: AuthConfigNanoId;
    status: 'ENABLED' | 'DISABLED';
};

export type PatchAuthConfigsByNanoidByStatusResponse = ({
    [key: string]: unknown;
});

export type PostCliCreateSessionResponse = ({
    /**
     * Unique identifier for the CLI session
     */
    id: string;
    /**
     * Temporary code to use for CLI login
     */
    code: string;
    /**
     * Expiration time of the session
     */
    expiresAt: string;
    /**
     * Current status of the session
     */
    status: 'pending' | 'linked';
});

export type GetCliGetSessionData = {
    /**
     * CLI session ID or code to check
     */
    id: string;
};

export type GetCliGetSessionResponse = ({
    /**
     * Unique identifier for the CLI session
     */
    id: string;
    /**
     * Temporary code used for CLI login
     */
    code: string;
    /**
     * Current status of the session
     */
    status: 'pending' | 'linked';
    /**
     * Expiration time of the session
     */
    expiresAt: string;
    /**
     * Information about the linked account, if any
     */
    account: {
        /**
         * ID of the linked account
         */
        id: string;
        /**
         * Email of the linked account
         */
        email: string;
        /**
         * Name of the linked account
         */
        name: string;
    } | null;
});

export type PutCliLinkSessionData = {
    requestBody?: {
        /**
         * CLI session ID or code to link
         */
        id: string;
    };
};

export type PutCliLinkSessionResponse = ({
    /**
     * Unique identifier for the CLI session
     */
    id: string;
    /**
     * Temporary code used for CLI login
     */
    code: string;
    /**
     * Current status of the session
     */
    status: 'pending' | 'linked';
    /**
     * Expiration time of the session
     */
    expiresAt: string;
    /**
     * Information about the linked account
     */
    account: {
        /**
         * ID of the linked account
         */
        id: string;
        /**
         * Email of the linked account
         */
        email: string;
        /**
         * Name of the linked account
         */
        name: string;
    };
});

export type GetConnectedAccountsData = {
    /**
     * The auth config ids of the connected accounts
     */
    authConfigIds?: Array<(string)> | null;
    /**
     * The cursor to paginate through the connected accounts
     */
    cursor?: (number) | null;
    /**
     * The labels of the connected accounts
     */
    labels?: Array<(string)> | null;
    /**
     * The limit of the connected accounts to return
     */
    limit?: (number) | null;
    /**
     * The order by of the connected accounts
     */
    orderBy?: 'created_at' | 'updated_at';
    /**
     * The status of the connected account
     */
    statuses?: Array<('ACTIVE' | 'INACTIVE' | 'DELETED' | 'INITIATED' | 'EXPIRED' | 'FAILED')> | null;
    /**
     * The toolkit slugs of the connected accounts
     */
    toolkitSlugs?: Array<(string)> | null;
    /**
     * The user ids of the connected accounts
     */
    userIds?: Array<(string)> | null;
};

export type GetConnectedAccountsResponse = ({
    items: Array<{
        toolkit: {
            /**
             * The slug of the toolkit
             */
            slug: string;
        };
        auth_config: {
            /**
             * The id of the auth config
             */
            id: AuthConfigNanoId;
            /**
             * The auth scheme of the auth config
             */
            auth_scheme: 'OAUTH2' | 'OAUTH1' | 'OAUTH1A' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH' | 'SNOWFLAKE';
            /**
             * Whether the auth config is managed by Composio
             */
            is_composio_managed: boolean;
            /**
             * Whether the auth config is disabled
             */
            is_disabled: boolean;
            deprecated?: {
                /**
                 * The uuid of the auth config
                 */
                uuid: string;
            };
        };
        /**
         * The id of the connection
         */
        id: ConnectedAccountNanoId;
        /**
         * The user id of the connection
         */
        user_id: string;
        /**
         * The status of the connection
         */
        status: 'ACTIVE' | 'INACTIVE' | 'DELETED' | 'INITIATED' | 'EXPIRED' | 'FAILED';
        /**
         * The created at of the connection
         */
        created_at: string;
        /**
         * The updated at of the connection
         */
        updated_at: string;
        /**
         * The data of the connection
         */
        data: {
            [key: string]: unknown;
        };
        /**
         * The reason the connection is disabled
         */
        status_reason: (string) | null;
        /**
         * Whether the connection is disabled
         */
        is_disabled: boolean;
        /**
         * The endpoint to make test request for verification
         */
        test_request_endpoint?: string;
        deprecated?: {
            /**
             * The labels of the connection
             */
            labels: Array<(string)>;
            /**
             * The uuid of the connection
             */
            uuid: string;
        };
    }>;
    next_cursor: (string) | null;
    total_pages: number;
});

export type PostConnectedAccountsData = {
    requestBody?: {
        auth_config: {
            /**
             * The auth config id of the app (must be a valid auth config id)
             */
            id: AuthConfigNanoId;
        };
        connection: {
            /**
             * Initial data to pass to the connected account
             */
            data?: {
                [key: string]: unknown;
            };
            /**
             * The user id of the connected account
             */
            user_id?: string;
            /**
             * The URL to redirect to after connection completion
             */
            callback_url?: string;
            /**
             * DEPRECATED: This parameter will be removed in a future version. Please use callback_url instead.
             * @deprecated
             */
            redirect_uri?: string;
            /**
             * Whether the connection is rerouted
             */
            deprecated_is_v1_rerouted?: boolean;
        };
    };
};

export type PostConnectedAccountsResponse = ({
    /**
     * The id of the connected account
     */
    id: ConnectedAccountNanoId;
    /**
     * The status of the connected account
     */
    status: 'ACTIVE' | 'INACTIVE' | 'DELETED' | 'INITIATED' | 'EXPIRED' | 'FAILED';
    /**
     * The URL to redirect to after connection completion
     */
    redirect_url: (string) | null;
    /**
     * DEPRECATED: This field will be removed in a future version. Please use redirect_url instead.
     * @deprecated
     */
    redirect_uri: (string) | null;
    deprecated: {
        /**
         * The uuid of the connected account
         */
        uuid: string;
        /**
         * The uuid of the auth config
         */
        authConfigUuid: string;
    };
});

export type GetConnectedAccountsByNanoidData = {
    /**
     * The id of the connected account
     */
    nanoid: ConnectedAccountNanoId;
};

export type GetConnectedAccountsByNanoidResponse = ({
    toolkit: {
        /**
         * The slug of the toolkit
         */
        slug: string;
    };
    auth_config: {
        /**
         * The id of the auth config
         */
        id: AuthConfigNanoId;
        /**
         * The auth scheme of the auth config
         */
        auth_scheme: 'OAUTH2' | 'OAUTH1' | 'OAUTH1A' | 'API_KEY' | 'BASIC' | 'BILLCOM_AUTH' | 'BEARER_TOKEN' | 'GOOGLE_SERVICE_ACCOUNT' | 'NO_AUTH' | 'BASIC_WITH_JWT' | 'COMPOSIO_LINK' | 'CALCOM_AUTH' | 'SNOWFLAKE';
        /**
         * Whether the auth config is managed by Composio
         */
        is_composio_managed: boolean;
        /**
         * Whether the auth config is disabled
         */
        is_disabled: boolean;
        deprecated?: {
            /**
             * The uuid of the auth config
             */
            uuid: string;
        };
    };
    /**
     * The id of the connection
     */
    id: ConnectedAccountNanoId;
    /**
     * The user id of the connection
     */
    user_id: string;
    /**
     * The status of the connection
     */
    status: 'ACTIVE' | 'INACTIVE' | 'DELETED' | 'INITIATED' | 'EXPIRED' | 'FAILED';
    /**
     * The created at of the connection
     */
    created_at: string;
    /**
     * The updated at of the connection
     */
    updated_at: string;
    /**
     * The data of the connection
     */
    data: {
        [key: string]: unknown;
    };
    /**
     * The reason the connected account is disabled
     */
    status_reason: (string) | null;
    /**
     * Whether the connected account is disabled
     */
    is_disabled: boolean;
    /**
     * The endpoint to make test request for verification
     */
    test_request_endpoint?: string;
    deprecated?: {
        /**
         * The labels of the connection
         */
        labels: Array<(string)>;
        /**
         * The uuid of the connection
         */
        uuid: string;
    };
    /**
     * The init data of the connection
     */
    params: {
        [key: string]: unknown;
    };
});

export type DeleteConnectedAccountsByNanoidData = {
    /**
     * The id of the connected account
     */
    nanoid: ConnectedAccountNanoId;
};

export type DeleteConnectedAccountsByNanoidResponse = ({
    /**
     * The success of the update
     */
    success: boolean;
});

export type PatchConnectedAccountsByNanoIdStatusData = {
    /**
     * The id of the connected account
     */
    nanoId: ConnectedAccountNanoId;
    requestBody?: {
        enabled: boolean;
    };
};

export type PatchConnectedAccountsByNanoIdStatusResponse = ({
    /**
     * The success of the update
     */
    success: boolean;
});

export type PostConnectedAccountsByNanoidRefreshData = {
    /**
     * The id of the connected account
     */
    nanoid: ConnectedAccountNanoId;
};

export type PostConnectedAccountsByNanoidRefreshResponse = ({
    /**
     * The id of the connected account
     */
    id: string;
    /**
     * The status of the connected account
     */
    status: 'ACTIVE' | 'INACTIVE' | 'DELETED' | 'INITIATED' | 'EXPIRED' | 'FAILED';
    /**
     * The redirect URL of the app (previously named redirect_uri)
     */
    redirect_url: (string) | null;
});

export type PostInternalTriggerLogsData = {
    requestBody?: {
        /**
         * Return logs from the last N time units
         */
        time?: '5m' | '30m' | '6h' | '1d' | '1w' | '1month' | '1y';
        /**
         * Filter logs by their status level
         */
        status?: 'all' | 'success' | 'error';
        /**
         * Search term to filter logs
         */
        search?: string;
        integrationId?: string;
        entityId?: string;
        /**
         * number of logs to return
         */
        limit?: number;
        /**
         * cursor that can be used to paginate through the logs
         */
        cursor: (string) | null;
    };
};

export type PostInternalTriggerLogsResponse = ({
    nextCursor: (string) | null;
    data?: Array<{
        id: string;
        connectionId: string;
        clientId: string;
        entityId: string;
        status: string;
        appName: string;
        createdAt: string;
        /**
         * Log entity type (trigger or action)
         */
        type: 'trigger' | 'action';
        meta: {
            id: string;
            /**
             * Log entity type (trigger or action)
             */
            type: 'trigger' | 'action';
            createdAt: string;
            updatedAt: string;
            provider: string;
            clientId: string;
            connectionId: string;
            triggerProviderPayload?: string;
            triggerClientPayload?: string;
            triggerClientError?: string;
            triggerName?: string;
            triggerClientResponse?: string;
        };
    }>;
});

export type PostInternalActionExecutionLogsData = {
    requestBody?: {
        /**
         * cursor_that_can_be_used_to_paginate_through_the_logs
         */
        cursor: (number) | null;
        /**
         * number_of_logs_to_return
         */
        limit?: number;
        /**
         * whether_the_search_is_case_sensitive_or_not
         */
        case_sensitive?: boolean;
        /**
         * start_time_of_the_logs_in_epoch_time
         */
        from?: number;
        /**
         * end_time_of_the_logs_in_epoch_time
         */
        to?: number;
        search_params?: Array<{
            field?: string;
            operation?: string;
            value?: string;
        }>;
    };
};

export type PostInternalActionExecutionLogsResponse = ({
    data: Array<{
        id: string;
        actionKey: string;
        appKey: string;
        app: {
            icon: string;
            name: string;
        };
        connectedAccountId: string;
        entityId: string;
        status: 'success' | 'failed';
        executionTime: number;
        minimalResponse: string;
        createdAt: number;
    }>;
    nextCursor: (number) | null;
});

export type GetInternalActionExecutionFieldsResponse = ({
    fields: {
        [key: string]: Array<{
            /**
             * The id of the field
             */
            id: string;
            /**
             * The display name of the field
             */
            displayName: string;
            /**
             * The type of the field
             */
            type: string;
            /**
             * The regex of the field
             */
            regex?: string;
        }>;
    };
});

export type GetInternalActionExecutionLogByIdData = {
    id: string;
};

export type GetInternalActionExecutionLogByIdResponse = ({
    actionLogId: string;
    actionId: string;
    status: 'success' | 'error' | 'warning' | 'info';
    app: {
        name: string;
        uniqueId: string;
        icon: string;
    };
    version: string;
    connection: {
        id?: string;
        entity: string;
    };
    session: {
        [key: string]: unknown;
    };
    executionMetadata: {
        [key: string]: unknown;
    };
    steps: Array<{
        type: 'tool_execution' | 'fetch_connection_details';
        startTime: number;
        endTime: number;
        totalDuration: number;
        status: 'success' | 'failure' | 'error';
        message: string;
        metadata?: {
            encryption?: string;
        };
        logs?: Array<{
            type: 'network' | 'system';
            level: string;
            message: string;
            requestId: string;
            time: number;
            request: {
                method: string;
                url: string;
                headers?: {
                    [key: string]: (string);
                };
                params?: {
                    [key: string]: unknown;
                };
                timeout?: number;
                json?: {
                    [key: string]: unknown;
                };
            };
            response: {
                status: number;
                time: string;
            };
        }>;
    }>;
    payloadReceived: {
        [key: string]: unknown;
    };
    startTime: number;
    endTime: number;
    totalDuration: string;
    response: {
        [key: string]: unknown;
    };
    error: {
        [key: string]: unknown;
    };
});

export type GetOpenapiSpecsListResponse = (Array<{
    id: string;
    name: string;
    created_at: string;
    updated_at: string;
    last_sync_at: string;
    status: string;
    state: string;
    logs: Array<{
        message: string;
        level: string;
        timestamp: string;
    }>;
    progress: {
        message: string;
    };
}>);

export type PostOpenapiSpecsCreateData = {
    requestBody?: {
        name: string;
        openApiSpec: string;
        authConfig: string;
    };
};

export type PostOpenapiSpecsCreateResponse = ({
    jobId: string;
});

export type DeleteOpenapiSpecsByIdData = {
    id: string;
};

export type DeleteOpenapiSpecsByIdResponse = ({
    [key: string]: unknown;
});

export type GetOpenapiSpecsStatusByIdData = {
    id: string;
};

export type GetOpenapiSpecsStatusByIdResponse = ({
    [key: string]: unknown;
});

export type GetOrgApiKeyResponse = ({
    org_api_key: string;
});

export type PostOrgApiKeyRegenerateResponse = ({
    org_api_key: string;
});

export type GetOrgProjectListResponse = ({
    data: Array<{
        id: ProjectNanoId;
        org_id: OrgNanoId;
        name: string;
        email: string;
        created_at: string;
        updated_at: string;
        webhook_url: (string) | null;
        event_webhook_url: (string) | null;
        webhook_secret: (string) | null;
        triggers_enabled?: boolean;
        last_subscribed_at?: (Date) | null;
        is_new_webhook?: boolean;
        deleted: boolean;
    }>;
});

export type PostOrgProjectNewData = {
    requestBody?: {
        /**
         * Name of the project
         */
        name: string;
    };
};

export type PostOrgProjectNewResponse = ({
    id: ProjectNanoId;
    org_id: OrgNanoId;
    name: string;
    email: string;
    created_at: string;
    updated_at: string;
    webhook_url: (string) | null;
    event_webhook_url: (string) | null;
    webhook_secret: (string) | null;
    triggers_enabled?: boolean;
    last_subscribed_at?: (Date) | null;
    is_new_webhook?: boolean;
    deleted: boolean;
});

export type DeleteOrgProjectDeleteByProjectIdData = {
    /**
     * Nano ID of the project
     */
    projectId: ProjectNanoId;
};

export type DeleteOrgProjectDeleteByProjectIdResponse = ({
    status: string;
});

export type GetOrgProjectByProjectIdData = {
    /**
     * Nano ID of the project
     */
    projectId: ProjectNanoId;
};

export type GetOrgProjectByProjectIdResponse = ({
    id: ProjectNanoId;
    org_id: OrgNanoId;
    name: string;
    email: string;
    created_at: string;
    updated_at: string;
    webhook_url: (string) | null;
    event_webhook_url: (string) | null;
    webhook_secret: (string) | null;
    triggers_enabled?: boolean;
    last_subscribed_at?: (Date) | null;
    is_new_webhook?: boolean;
    deleted: boolean;
});

export type GetOrgProjectByProjectIdApiKeysListData = {
    /**
     * Nano ID of the project
     */
    projectId: ProjectNanoId;
};

export type GetOrgProjectByProjectIdApiKeysListResponse = ({
    /**
     * List of API keys
     */
    items: Array<{
        /**
         * API key ID
         */
        id: string;
        /**
         * API key name
         */
        name: string;
        /**
         * API key value
         */
        key: string;
        /**
         * Creation timestamp
         */
        created_at: Date;
        /**
         * Last used timestamp
         */
        last_used?: Date;
    }>;
});

export type PostOrgProjectByProjectIdApiKeysCreateData = {
    /**
     * Project ID
     */
    projectId: ProjectNanoId;
    requestBody?: {
        /**
         * API key name
         */
        name: string;
    };
};

export type PostOrgProjectByProjectIdApiKeysCreateResponse = ({
    /**
     * API key ID
     */
    id: string;
    /**
     * API key name
     */
    name: string;
    /**
     * API key value
     */
    key: string;
    /**
     * Creation timestamp
     */
    createdAt: Date;
    /**
     * Last used timestamp
     */
    lastUsed?: Date;
});

export type PostOrgProjectByProjectIdApiKeysCreateApiKeyData = {
    /**
     * Project ID
     */
    projectId: string;
};

export type PostOrgProjectByProjectIdApiKeysCreateApiKeyResponse = ({
    /**
     * API key ID
     */
    id: string;
    /**
     * API key name
     */
    name: string;
    /**
     * API key value
     */
    key: string;
    /**
     * Creation timestamp
     */
    createdAt: Date;
    /**
     * Last used timestamp
     */
    lastUsed?: Date;
});

export type DeleteOrgProjectByProjectIdApiKeysRemoveByIdData = {
    /**
     * API key ID
     */
    id: string;
    /**
     * Project ID
     */
    projectId: ProjectNanoId;
};

export type DeleteOrgProjectByProjectIdApiKeysRemoveByIdResponse = ({
    /**
     * Whether the operation was successful
     */
    success: boolean;
    /**
     * Status message
     */
    message: string;
});

export type GetOrgProjectWebhookData = {
    /**
     * Type of the webhook
     */
    type: 'trigger' | 'event';
};

export type GetOrgProjectWebhookResponse = ({
    url: ({
    type: 'trigger';
    /**
     * Webhook URL
     */
    webhook_url?: string;
} | {
    type: 'event';
    /**
     * Event webhook URL
     */
    event_webhook_url?: string;
});
    /**
     * Webhook secret
     */
    webhook_secret: string;
    /**
     * Status of the webhook
     */
    status: 'success' | 'not found';
});

export type DeleteOrgProjectWebhookData = {
    requestBody?: {
        /**
         * Type of the webhook
         */
        type: 'trigger' | 'event';
    };
};

export type DeleteOrgProjectWebhookResponse = ({
    status: 'success';
});

export type PostOrgProjectWebhookUpdateData = {
    requestBody?: {
        /**
         * Type of the webhook
         */
        type: 'trigger' | 'event';
        /**
         * Webhook URL
         */
        webhook_url: string;
    };
};

export type PostOrgProjectWebhookUpdateResponse = ({
    /**
     * Whether the operation was successful
     */
    success: boolean;
    /**
     * Status message
     */
    message: string;
});

export type PostOrgProjectWebhookRefreshResponse = ({
    /**
     * Whether the operation was successful
     */
    success: boolean;
    /**
     * Status message
     */
    message: string;
    /**
     * Webhook secret
     */
    webhook_secret: string;
});

export type GetTeamMembersListResponse = ({
    items: Array<{
        id: string;
        email: string;
        name: string;
        role: string;
        createdAt: (string);
        updatedAt: (string);
    }>;
});

export type PostTeamMembersInviteData = {
    requestBody?: InviteTeamMemberBody;
};

export type PostTeamMembersInviteResponse = ({
    id: string;
    email: string;
    name: string;
    role: string;
    createdAt: (string);
    updatedAt: (string);
});

export type DeleteTeamMembersRemoveByIdData = {
    id: string;
};

export type DeleteTeamMembersRemoveByIdResponse = ({
    success: boolean;
    message: string;
});

export type PutTeamMembersUpdateByIdData = {
    id: string;
    requestBody?: UpdateTeamMemberBody;
};

export type PutTeamMembersUpdateByIdResponse = ({
    id: string;
    email: string;
    name: string;
    role: string;
    createdAt: (string);
    updatedAt: (string);
});

export type GetToolkitsData = {
    category?: string;
    isLocal?: (boolean) | null;
    managedBy?: 'composio' | 'all' | 'project';
    sortBy?: 'usage' | 'alphabetically';
};

export type GetToolkitsResponse = ({
    items: Array<{
        slug: string;
        name: string;
        auth_schemes?: Array<(string)>;
        composio_managed_auth_schemes?: Array<(string)>;
        is_local_toolkit: boolean;
        no_auth?: boolean;
        meta: {
            created_at: string;
            updated_at: string;
            description: string;
            logo: string;
            app_url?: (string) | null;
            categories: Array<{
                id: string;
                name: string;
            }>;
            triggers_count: number;
            tools_count: number;
        };
    }>;
    next_cursor: (string) | null;
    total_pages: number;
});

export type GetToolkitsCategoriesResponse = ({
    items: Array<{
        name: string;
        id: string;
    }>;
    next_cursor: (string) | null;
    total_pages: number;
});

export type GetToolkitsBySlugData = {
    slug: string;
};

export type GetToolkitsBySlugResponse = ({
    slug: string;
    name: string;
    enabled: boolean;
    composio_managed_auth_schemes?: Array<(string)>;
    auth_config_details?: Array<{
        mode: string;
        fields: {
            auth_config_creation: {
                required: Array<{
                    name: string;
                    displayName: string;
                    default?: (string) | null;
                    type: string;
                    description: string;
                    required: boolean;
                }>;
                optional: Array<{
                    name: string;
                    displayName: string;
                    default?: (string) | null;
                    type: string;
                    description: string;
                    required: boolean;
                }>;
            };
            connected_account_initiation: {
                required: Array<{
                    name: string;
                    displayName: string;
                    default?: (string) | null;
                    type: string;
                    description: string;
                    required: boolean;
                }>;
                optional: Array<{
                    name: string;
                    displayName: string;
                    default?: (string) | null;
                    type: string;
                    description: string;
                    required: boolean;
                }>;
            };
        };
        proxy?: {
            base_url: string;
        };
        name: string;
    }>;
    is_local_toolkit: boolean;
    meta: {
        created_at: string;
        updated_at: string;
        description: string;
        logo: string;
        app_url?: (string) | null;
        categories: Array<{
            name: string;
            slug: string;
        }>;
        triggers_count: number;
        tools_count: number;
    };
});

export type GetToolsData = {
    cursor?: string;
    important?: string;
    limit?: string;
    search?: string;
    /**
     * The tags to filter the tools by
     */
    tags?: Array<(string)> | null;
    toolkitSlug?: string;
    toolSlugs?: Array<(string)> | null;
};

export type GetToolsResponse = ({
    items: Array<{
        /**
         * The slug of the tool
         */
        slug: string;
        /**
         * The name of the tool
         */
        name: string;
        /**
         * The description of the tool
         */
        description: string;
        toolkit: {
            /**
             * The slug of the toolkit
             */
            slug: string;
            /**
             * The name of the toolkit
             */
            name: string;
        };
        /**
         * The input parameters of the tool
         */
        input_parameters: {
            [key: string]: unknown;
        };
        /**
         * Whether the tool requires authentication
         */
        no_auth: boolean;
        /**
         * The output parameters of the tool
         */
        output_parameters: {
            [key: string]: unknown;
        };
        /**
         * The tags of the tool
         */
        tags: Array<(string)>;
        deprecated: {
            /**
             * The display name of the tool
             */
            displayName: string;
            /**
             * The version of the tool
             */
            version: string;
            /**
             * The available versions of the tool
             */
            available_versions: Array<(string)>;
            /**
             * Whether the tool is deprecated
             */
            is_deprecated: boolean;
            toolkit: {
                /**
                 * The logo of the toolkit
                 */
                logo: string;
            };
        };
    }>;
    next_cursor: (string) | null;
    total_pages: number;
});

export type GetToolsEnumResponse = (string);

export type GetToolsByToolSlugData = {
    toolSlug: string;
};

export type GetToolsByToolSlugResponse = ({
    slug: string;
    name: string;
    description: string;
    input_parameters: {
        [key: string]: unknown;
    };
    output_parameters: {
        [key: string]: unknown;
    };
    tags: Array<(string)>;
    toolkit: {
        slug: string;
        name: string;
        logo: string;
    };
    available_versions: Array<(string)>;
    version: string;
    deprecated: {
        /**
         * The display name of the tool
         */
        displayName: string;
        /**
         * Whether the action is deprecated
         */
        is_deprecated: boolean;
    };
    no_auth: boolean;
});

export type PostToolsExecuteByActionData = {
    /**
     * The name of the action
     */
    action: string;
    requestBody?: {
        connected_account_id?: string;
        entity_id?: string;
        version?: string;
        /**
         * An optional field for people who want to use their own auth to execute the action.
         */
        custom_auth_params?: {
            /**
             * The base URL (root address) what you should use while making http requests to the connected account. For example, for gmail, it would be 'https://gmail.googleapis.com'
             */
            base_url?: string;
            parameters: Array<{
                /**
                 * The name of the parameter. For example, 'x-api-key', 'Content-Type', etc.
                 */
                name: string;
                /**
                 * The location of the parameter. Can be 'query' or 'header'.
                 */
                in: 'query' | 'header';
                /**
                 * The value of the parameter. For example, '1234567890', 'application/json', etc.
                 */
                value: (string | number);
            }>;
            /**
             * The body to be sent to the endpoint for authentication. This is a JSON object. Note: This is very rarely neeed and is only required by very few apps.
             */
            body?: {
                [key: string]: unknown;
            };
        };
        arguments?: {
            [key: string]: unknown;
        };
        text?: string;
        allow_tracing?: boolean;
    };
};

export type PostToolsExecuteByActionResponse = ({
    data: {
        [key: string]: unknown;
    };
    error: (string) | null;
    successful: boolean;
    session_info?: unknown;
    log_id?: string;
});

export type PostToolsExecuteByActionNameInputData = {
    /**
     * The name of the action to get inputs for
     */
    actionName: string;
    requestBody?: {
        /**
         * The use-case description for the action, this will give context to LLM to generate the correct inputs for the action.
         */
        text: string;
        /**
         * The custom description for the action, use this to provide customised context about the action to the LLM to suit your use-case.
         */
        customDescription?: string;
        /**
         * The system prompt to be used by LLM, use this to control and guide the behaviour of the LLM.
         */
        systemPrompt?: string;
        version?: string;
    };
};

export type PostToolsExecuteByActionNameInputResponse = ({
    /**
     * The arguments for the action needed to execute the given task.
     */
    arguments?: {
        [key: string]: unknown;
    };
    /**
     * The error message if the arguments were not generated successfully.
     */
    error?: string;
});

export type PostToolsExecuteProxyData = {
    requestBody?: {
        connected_account_id?: ConnectedAccountNanoId;
        endpoint: string;
        method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
        body?: unknown;
        parameters?: Array<{
            name: string;
            value: string;
            type: 'header' | 'query';
        }>;
    };
};

export type PostToolsExecuteProxyResponse = ({
    data?: unknown;
    status: number;
    headers?: {
        [key: string]: (string);
    };
});

export type GetTriggerInstancesBySlugByProjectIdHandleData = {
    projectId: (string | 'default');
    /**
     * The slug of the trigger instance
     */
    slug: string;
};

export type GetTriggerInstancesBySlugByProjectIdHandleResponse = (string);

export type PostTriggerInstancesBySlugByProjectIdHandleData = {
    projectId: (string | 'default');
    /**
     * The slug of the trigger instance
     */
    slug: string;
};

export type PostTriggerInstancesBySlugByProjectIdHandleResponse = (string);

export type HeadTriggerInstancesBySlugByProjectIdHandleData = {
    projectId: (string | 'default');
    /**
     * The slug of the trigger instance
     */
    slug: string;
};

export type HeadTriggerInstancesBySlugByProjectIdHandleResponse = (string);

export type PatchTriggerInstancesBySlugStatusByStatusData = {
    /**
     * The slug of the trigger instance
     */
    slug: string;
    /**
     * The new status of the trigger
     */
    status: 'enable' | 'disable';
};

export type PatchTriggerInstancesBySlugStatusByStatusResponse = ({
    /**
     * Status of the operation
     */
    status: 'success';
});

export type PostTriggerInstancesBySlugUpsertData = {
    requestBody?: {
        /**
         * Connection ID
         */
        connectedAuthId: ConnectedAccountNanoId;
        /**
         * Trigger configuration
         */
        triggerConfig: {
            [key: string]: unknown;
        };
    };
    /**
     * The slug of the trigger instance
     */
    slug: string;
};

export type PostTriggerInstancesBySlugUpsertResponse = ({
    /**
     * ID of the updated trigger
     */
    triggerId: string;
} | EmptyResponse);

export type DeleteTriggerInstancesBySlugUpsertData = {
    /**
     * The slug of the trigger instance
     */
    slug: string;
};

export type DeleteTriggerInstancesBySlugUpsertResponse = ({
    /**
     * ID of the updated trigger
     */
    triggerId: string;
});

export type GetTriggerInstancesActiveData = {
    /**
     * Array of auth config IDs to filter triggers by
     */
    authConfigIds?: Array<(string)> | null;
    /**
     * Array of connected account IDs to filter triggers by
     */
    connectedAccountIds?: Array<(string)> | null;
    /**
     * Array of auth config UUIDs to filter triggers by
     */
    deprecatedAuthConfigUuids?: Array<(string)> | null;
    /**
     * Array of connected account UUIDs to filter triggers by
     */
    deprecatedConnectedAccountUuids?: Array<(string)> | null;
    /**
     * Number of items to return per page.
     */
    limit?: number;
    /**
     * Page number for pagination. Starts from 1.
     */
    page?: number;
    /**
     * When set to true, includes disabled triggers in the response.
     */
    showDisabled?: (string) | null;
    /**
     * Array of trigger IDs to filter triggers by
     */
    triggerIds?: Array<(string)> | null;
    /**
     * Array of trigger names to filter triggers by
     */
    triggerNames?: Array<(string)> | null;
};

export type GetTriggerInstancesActiveResponse = ({
    items: Array<{
        /**
         * Unique identifier of the trigger instance
         */
        uuid?: string;
        /**
         * Nano ID of the trigger instance
         */
        id: TriggerInstanceNanoId;
        /**
         * ID of the connected account this trigger is associated with
         */
        connectedAccountId: string;
        /**
         * Name of the trigger
         */
        triggerName: string;
        /**
         * Additional data associated with the trigger instance
         */
        triggerData?: string;
        /**
         * Configuration for the trigger
         */
        triggerConfig: {
            [key: string]: unknown;
        };
        /**
         * State of the trigger instance
         */
        state: {
            [key: string]: unknown;
        };
        /**
         * ISO 8601 timestamp when the trigger instance was updated
         */
        updatedAt: string;
        /**
         * ISO 8601 timestamp when the trigger instance was disabled, if applicable
         */
        disabledAt: (string) | null;
        /**
         * Deprecated fields for the trigger instance
         */
        deprecated?: {
            /**
             * Deprecated createdAt for the trigger instance
             */
            createdAt: string;
        };
    }>;
    next_cursor: (string) | null;
    total_pages: number;
});

export type GetTriggersTypesListEnumResponse = (string);

export type GetTriggersTypesBySlugData = {
    slug: string;
};

export type GetTriggersTypesBySlugResponse = ({
    slug: string;
    name: string;
    config: {
        [key: string]: unknown;
    };
    payload: {
        [key: string]: unknown;
    };
    description: string;
    instructions: string;
    toolkit: {
        uuid: string;
        name: string;
        logo: string;
    };
});

export type GetTriggersTypesData = {
    cursor?: string;
    limit?: (number) | null;
    /**
     * Array of toolkit slugs
     */
    toolkitSlugs?: Array<(string)> | null;
};

export type GetTriggersTypesResponse = ({
    items: Array<{
        slug: string;
        name: string;
        description: string;
        type: 'webhook' | 'poll';
        toolkit: {
            slug: string;
            name: string;
        };
        config: {
            [key: string]: unknown;
        };
        payload: {
            [key: string]: unknown;
        };
    }>;
    next_cursor: (string) | null;
    total_pages: number;
});

export type GetOrgProjectTriggerResponse = ({
    id: ProjectNanoId;
    org_id: OrgNanoId;
    name: string;
    email: string;
    created_at: string;
    updated_at: string;
    webhook_url: (string) | null;
    event_webhook_url: (string) | null;
    webhook_secret: (string) | null;
    triggers_enabled?: boolean;
    last_subscribed_at?: (Date) | null;
    is_new_webhook?: boolean;
    deleted: boolean;
});

export type PatchOrgProjectTriggerData = {
    /**
     * Enabled
     */
    enabled: boolean;
};

export type PatchOrgProjectTriggerResponse = ({
    id: ProjectNanoId;
    org_id: OrgNanoId;
    name: string;
    email: string;
    created_at: string;
    updated_at: string;
    webhook_url: (string) | null;
    event_webhook_url: (string) | null;
    webhook_secret: (string) | null;
    triggers_enabled?: boolean;
    last_subscribed_at?: (Date) | null;
    is_new_webhook?: boolean;
    deleted: boolean;
});

export type PostPaymentsSessionData = {
    requestBody?: {
        /**
         * Subscription plan to purchase
         */
        plan: 'HOBBY' | 'STARTER' | 'GROWTH';
        /**
         * Whether to apply discount coupon
         */
        applyDiscount: boolean;
    };
};

export type PostPaymentsSessionResponse = ({
    /**
     * URL to the payment page
     */
    url: string;
    /**
     * ID of the created payment session
     */
    sessionId: string;
});

export type PostPaymentsManageSubscriptionData = {
    requestBody?: {
        [key: string]: unknown;
    };
};

export type PostPaymentsManageSubscriptionResponse = ({
    /**
     * URL to the Stripe billing portal
     */
    url: string;
    /**
     * ID of the created billing portal session
     */
    sessionId: string;
});

export type GetAdminCreatePaymentLinkData = {
    /**
     * Payment amount in cents
     */
    amount: number;
    /**
     * Description of the payment
     */
    description?: string;
    /**
     * Customer email address
     */
    email: string;
};

export type GetAdminCreatePaymentLinkResponse = ({
    /**
     * URL to the Stripe payment page
     */
    url: string;
    /**
     * ID of the created payment session
     */
    sessionId: string;
});

export type PostMcpCommandGenerateData = {
    requestBody?: {
        /**
         * The ID of the MCP server
         */
        id: string;
        /**
         * MCP client to generate command for
         */
        mcp_client: 'cursor' | 'claude' | 'windsurf';
        /**
         * Time to live for the command
         */
        ttl?: '1d' | '3d' | '1 month' | 'no expiration';
    };
};

export type PostMcpCommandGenerateResponse = ({
    /**
     * The generated command to run
     */
    command?: string;
    /**
     * The URL for the MCP server
     */
    url?: string;
});

export type GetMcpValidateByUuidData = {
    /**
     * UUID of the MCP server to validate
     */
    uuid: string;
    /**
     * Admin token
     */
    xComposioAdminToken: string;
};

export type GetMcpValidateByUuidResponse = ({
    /**
     * The ID of the MCP server
     */
    id: string;
    /**
     * The name of the MCP server
     */
    name: string;
    /**
     * The URL of the MCP server
     */
    url: string;
    client: {
        /**
         * The client ID
         */
        id: string;
        /**
         * The organization ID
         */
        orgId: string;
    };
    userData: {
        /**
         * The user ID
         */
        id: string;
        /**
         * The user email
         */
        email: string;
        /**
         * The API key
         */
        apiKey: string;
    };
    apps?: Array<(string)>;
    actions?: Array<(string)> | null;
    customAuthHeaders?: boolean;
    entityIds?: Array<(string)> | null;
    connectedAccountIds?: Array<(string)> | null;
});

export type PostMcpCreateData = {
    requestBody?: {
        /**
         * Name of the MCP server
         */
        name: string;
        /**
         * App IDs associated with the server
         */
        apps?: Array<(string)>;
        /**
         * Connected account IDs
         */
        connected_account_ids?: Array<(string)>;
        /**
         * Entity IDs
         */
        entity_ids?: Array<(string)>;
        /**
         * Actions available for the server
         */
        actions?: Array<(string)>;
        /**
         * Time to live for the server
         */
        ttl?: '1d' | '3d' | '1 month' | 'no expiration';
        /**
         * Auth configurations
         */
        auth_configs?: {
            [key: string]: unknown;
        };
        /**
         * Whether to use custom auth headers
         */
        custom_auth_headers?: boolean;
    };
};

export type PostMcpCreateResponse = ({
    /**
     * The ID of the MCP server
     */
    id: string;
    /**
     * The name of the MCP server
     */
    name: string;
    /**
     * The URL of the MCP server
     */
    url: string;
    /**
     * The app IDs associated with the server
     */
    apps: Array<(string)>;
    /**
     * The member ID who created the server
     */
    member_id: string;
    /**
     * Last update timestamp of the MCP server
     */
    updated_at: string;
    /**
     * Connected account IDs
     */
    connected_account_ids?: Array<(string)>;
    /**
     * Auth configuration
     */
    auth_configs?: {
        [key: string]: unknown;
    };
    /**
     * Signed URL for the MCP server
     */
    signed_url: string;
});

export type GetMcpByIdData = {
    /**
     * The ID of the MCP server
     */
    id: string;
};

export type GetMcpByIdResponse = ({
    /**
     * The ID of the MCP server
     */
    id: string;
    /**
     * The name of the MCP server
     */
    name: string;
    /**
     * The URL of the MCP server
     */
    url: string;
    /**
     * The app IDs associated with the server
     */
    apps: Array<(string)>;
    /**
     * The member ID who created the server
     */
    member_id: string;
    /**
     * Last update timestamp of the MCP server
     */
    updated_at: string;
    /**
     * Connected account IDs
     */
    connected_account_ids?: Array<(string)>;
    /**
     * Auth configuration
     */
    auth_configs?: {
        [key: string]: unknown;
    };
    /**
     * Actions available for the MCP server
     */
    actions?: {
        [key: string]: unknown;
    };
    /**
     * Entity IDs associated with the server
     */
    entity_ids?: Array<(string)>;
    /**
     * Creation timestamp of the MCP server
     */
    created_at: string;
    /**
     * Client ID associated with the MCP server
     */
    client_id: string;
    /**
     * Whether the MCP server is deleted
     */
    deleted: boolean;
    /**
     * Whether custom auth headers are enabled
     */
    custom_auth_headers?: boolean;
});

export type PatchMcpByIdData = {
    /**
     * The ID of the MCP server
     */
    id: string;
    requestBody?: {
        /**
         * Name of the MCP server
         */
        name?: string;
        /**
         * App IDs associated with the server
         */
        apps?: Array<(string)>;
        /**
         * Actions available for the server
         */
        actions?: Array<(string)>;
    };
};

export type PatchMcpByIdResponse = ({
    /**
     * The ID of the MCP server
     */
    id: string;
    /**
     * The name of the MCP server
     */
    name: string;
    /**
     * The URL of the MCP server
     */
    url: string;
    /**
     * The app IDs associated with the server
     */
    apps: Array<(string)>;
    /**
     * The member ID who created the server
     */
    member_id: string;
    /**
     * Last update timestamp of the MCP server
     */
    updated_at: string;
    /**
     * Connected account IDs
     */
    connected_account_ids?: Array<(string)>;
    /**
     * Auth configuration
     */
    auth_configs?: {
        [key: string]: unknown;
    };
    /**
     * Actions available for the MCP server
     */
    actions?: {
        [key: string]: unknown;
    };
    /**
     * Entity IDs associated with the server
     */
    entity_ids?: Array<(string)>;
    /**
     * Creation timestamp of the MCP server
     */
    created_at: string;
    /**
     * Client ID associated with the MCP server
     */
    client_id: string;
    /**
     * Whether the MCP server is deleted
     */
    deleted: boolean;
    /**
     * Whether custom auth headers are enabled
     */
    custom_auth_headers?: boolean;
});

export type DeleteMcpByIdData = {
    /**
     * The ID of the MCP server
     */
    id: string;
};

export type DeleteMcpByIdResponse = ({
    /**
     * Operation success status
     */
    success: boolean;
});

export type GetMcpAppByAppKeyData = {
    /**
     * The key of the app to find MCP servers for
     */
    appKey: string;
};

export type GetMcpAppByAppKeyResponse = ({
    items: Array<{
        /**
         * The ID of the MCP server
         */
        id: string;
        /**
         * The name of the MCP server
         */
        name: string;
        /**
         * The URL of the MCP server
         */
        url: string;
        /**
         * The app IDs associated with the server
         */
        apps: Array<(string)>;
        /**
         * The member ID who created the server
         */
        member_id: string;
        /**
         * Last update timestamp of the MCP server
         */
        updated_at: string;
        /**
         * Connected account IDs
         */
        connected_account_ids?: Array<(string)>;
        /**
         * Auth configuration
         */
        auth_configs?: {
            [key: string]: unknown;
        };
        /**
         * Actions available for the MCP server
         */
        actions?: Array<(string)>;
    }>;
});

export type GetMcpListData = {
    /**
     * App IDs to filter by
     */
    appId?: Array<(string)> | null;
    /**
     * Connected account IDs to filter by
     */
    connectedAccountId?: Array<(string)> | null;
    /**
     * Cursor for pagination
     */
    cursor?: (number) | null;
    /**
     * Entity IDs to filter by
     */
    entityId?: Array<(string)> | null;
    /**
     * Integration ID to filter by
     */
    integrationId?: string;
    /**
     * Limit for pagination
     */
    limit?: (number) | null;
};

export type GetMcpListResponse = ({
    items: Array<{
        /**
         * The ID of the MCP server
         */
        id: string;
        /**
         * The name of the MCP server
         */
        name: string;
        /**
         * The URL of the MCP server
         */
        url: string;
        /**
         * The app IDs associated with the server
         */
        apps: Array<(string)>;
        /**
         * The member ID who created the server
         */
        member_id: string;
        /**
         * Last update timestamp of the MCP server
         */
        updated_at: string;
        /**
         * Connected account IDs
         */
        connected_account_ids?: Array<(string)>;
        /**
         * Auth configuration
         */
        auth_configs?: {
            [key: string]: unknown;
        };
        /**
         * Actions available for the MCP server
         */
        actions?: Array<(string)>;
    }>;
});

export type GetFilesListData = {
    /**
     * Slug of the app where this file belongs to.
     */
    toolkitSlug?: string;
    /**
     * Name of the action where this file belongs to.
     */
    toolSlug?: string;
};

export type GetFilesListResponse = ({
    items: Array<{
        /**
         * Slug of the app where this file belongs to.
         */
        toolkit_slug: string;
        /**
         * Name of the action where this file belongs to.
         */
        tool_slug: string;
        /**
         * Name of the original file.
         */
        filename: string;
        /**
         * Mime type of the original file.
         */
        mimetype: string;
        /**
         * MD5 of a file.
         */
        md5: string;
    }>;
    next_cursor: (string) | null;
    total_pages: number;
});

export type PostFilesUploadRequestData = {
    requestBody?: {
        /**
         * Slug of the app where this file belongs to.
         */
        toolkit_slug: string;
        /**
         * Slug of the action where this file belongs to.
         */
        tool_slug: string;
        /**
         * Name of the original file.
         */
        filename: string;
        /**
         * Mime type of the original file.
         */
        mimetype: string;
        /**
         * MD5 of a file.
         */
        md5: string;
    };
};

export type PostFilesUploadRequestResponse = (({
    /**
     * ID of the request file
     */
    id: string;
    /**
     * S3 upload location
     */
    key: string;
    /**
     * URL of the existing request file
     */
    existingUrl: string;
    type: 'existing';
} | {
    /**
     * ID of the request file
     */
    id: string;
    /**
     * S3 upload location
     */
    key: string;
    /**
     * Presigned URL for upload
     */
    newPresignedUrl: string;
    type: 'new';
} | {
    /**
     * ID of the request file
     */
    id: string;
    /**
     * S3 upload location
     */
    key: string;
    /**
     * Presigned URL for upload
     */
    updatePresignedUrl: string;
    type: 'update';
}));

export type PostFilesUploadResponseData = {
    /**
     * Required admin token for authorization to upload response files
     */
    adminToken: string;
    requestBody?: {
        /**
         * Slug of the app where this response file belongs to.
         */
        toolkit_slug: string;
        /**
         * Slug of the action where this response file belongs to.
         */
        tool_slug: string;
        /**
         * Name of the original response file.
         */
        filename: string;
        /**
         * Mime type of the original response file.
         */
        mimetype: string;
        /**
         * MD5 of the response file.
         */
        md5: string;
    };
};

export type PostFilesUploadResponseResponse = (({
    /**
     * ID of the response file
     */
    id: string;
    /**
     * S3 upload location
     */
    key: string;
    /**
     * URL of the existing response file
     */
    existingUrl: string;
    type: 'existing';
} | {
    /**
     * ID of the response file
     */
    id: string;
    /**
     * S3 upload location
     */
    key: string;
    /**
     * Presigned URL for response file upload
     */
    newPresignedUrl: string;
    type: 'new';
} | {
    /**
     * ID of the response file
     */
    id: string;
    /**
     * S3 upload location
     */
    key: string;
    /**
     * Presigned URL for response file upload
     */
    updatePresignedUrl: string;
    type: 'update';
}));

export type GetMigrationGetNanoidData = {
    type: 'CONNECTED_ACCOUNT' | 'AUTH_CONFIG' | 'TRIGGER_INSTANCE';
    uuid: string;
    xApiKey: string;
};

export type GetMigrationGetNanoidResponse = ({
    /**
     * The NanoId corresponding to the provided UUID.
     */
    nanoid: string;
});

export type PostOrgProjectNewResponseTransformer = (data: any) => Promise<PostOrgProjectNewResponse>;

export const PostOrgProjectNewResponseTransformer: PostOrgProjectNewResponseTransformer = async (data) => {
    if (data?.last_subscribed_at) {
        data.last_subscribed_at = new Date(data.last_subscribed_at);
    }
    return data;
};

export type GetOrgProjectByProjectIdResponseTransformer = (data: any) => Promise<GetOrgProjectByProjectIdResponse>;

export const GetOrgProjectByProjectIdResponseTransformer: GetOrgProjectByProjectIdResponseTransformer = async (data) => {
    if (data?.last_subscribed_at) {
        data.last_subscribed_at = new Date(data.last_subscribed_at);
    }
    return data;
};

export type PostOrgProjectByProjectIdApiKeysCreateResponseTransformer = (data: any) => Promise<PostOrgProjectByProjectIdApiKeysCreateResponse>;

export const PostOrgProjectByProjectIdApiKeysCreateResponseTransformer: PostOrgProjectByProjectIdApiKeysCreateResponseTransformer = async (data) => {
    if (data?.createdAt) {
        data.createdAt = new Date(data.createdAt);
    }
    if (data?.lastUsed) {
        data.lastUsed = new Date(data.lastUsed);
    }
    return data;
};

export type GetOrgProjectTriggerResponseTransformer = (data: any) => Promise<GetOrgProjectTriggerResponse>;

export const GetOrgProjectTriggerResponseTransformer: GetOrgProjectTriggerResponseTransformer = async (data) => {
    if (data?.last_subscribed_at) {
        data.last_subscribed_at = new Date(data.last_subscribed_at);
    }
    return data;
};

export type PatchOrgProjectTriggerResponseTransformer = (data: any) => Promise<PatchOrgProjectTriggerResponse>;

export const PatchOrgProjectTriggerResponseTransformer: PatchOrgProjectTriggerResponseTransformer = async (data) => {
    if (data?.last_subscribed_at) {
        data.last_subscribed_at = new Date(data.last_subscribed_at);
    }
    return data;
};